import $ from 'jquery';

export default function nbnMapSection() {
	const $html = $('html');
	const $scroller = $('html, body');
	const map = $('.nbn-map');

	if (map.length) {
		let iframe = map.find('> iframe');

		iframe.on('load', function(){
			let _this = this;
			// setTimeout(()=>{
			// 	let iframeHeight = $(_this).height();
			// 	$(_this).css('height', iframeHeight + 'px');
			// 	map.addClass('is-updated');
			// }, 100);
		});
	}
}



// WEBPACK FOOTER //
// ./source/scripts/sections/nbn-map.js